import { Injectable } from "@angular/core";

import { FirmatarioDTO } from "@app/shared/dto/firmatarioDTO";
import { FirmatarioVO } from "@app/shared/vo/firmatarioVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { MapperProfilo } from "@app/shared/mapper/mapper-profilo";

@Injectable({
  providedIn: "root"
})
export class MapperFirmatario implements MapperInterface<FirmatarioDTO, FirmatarioVO> {
  constructor(private mapperProfilo: MapperProfilo) { }

  convertVoToDto(firmatarioVO: FirmatarioVO): FirmatarioDTO {
    // console.log("[MapperUtente] firmatarioVO => firmatarioDTO");
    const firmatarioDTO = new FirmatarioDTO();
    if (firmatarioVO != null) {
      firmatarioDTO.cmu = firmatarioVO.cmu;
      firmatarioDTO.cf = firmatarioVO.cf;
      firmatarioDTO.descrizione = firmatarioVO.descrizione;
     }
    return firmatarioDTO || new FirmatarioDTO();
  }

  convertDtoToVo(firmatarioDTO: FirmatarioDTO): FirmatarioVO {

    const firmatarioVO = new FirmatarioVO();
    if (firmatarioDTO) {
      firmatarioVO.cmu = firmatarioDTO.cmu;
      firmatarioVO.cf = firmatarioDTO.cf;
      firmatarioVO.descrizione = firmatarioDTO.descrizione;
    }
    return firmatarioVO || new FirmatarioVO();
  }

  convertListVoToDto(firmatarioVOList: FirmatarioVO[]): FirmatarioDTO[] {
    const firmatarioDTOList = new Array<FirmatarioDTO>();
    if (firmatarioVOList != null && firmatarioVOList.length > 0) {
      firmatarioVOList.forEach(ufficioVO => {
        firmatarioDTOList.push(this.convertVoToDto(ufficioVO));
      });
    }
    return firmatarioDTOList || new Array<FirmatarioDTO>();
  }
  convertListDtoToVo(firmatarioDTOList: FirmatarioDTO[]): FirmatarioVO[] {
    if (firmatarioDTOList !== undefined) {
      return firmatarioDTOList.map(dto => this.convertDtoToVo(dto));
    } else {
      return new Array<FirmatarioVO>();
    }
  }
}
